import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../redux/actions';
import { iconForField } from '../../../../common/custom/icon-library';
import CustomRadio from '../../../../common/ui/CustomRadio';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import CustomInputWithIconNoFormGroup from '../../../../common/ui/CustomInputWithIconNoFormGroup';

export class ImportExportItem extends Component {
  static propTypes = {
    events: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      schema[args.name] = dbParameters ? dbParameters.value : '';
    });
    return schema;
  };

  handleSubmit = (values) => {
    const { actionData, actions, projectId, version, selectedEvent } = this.props;
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId: projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  collectionOptions = () => {
    let options = [];
    let collections = this.props.events.collections;
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => ({
          value: collection.collectionName,
          label: collection.collectionTitle,
        })),
      );
    }
    return options;
  };

  closeAllOpenPopup = () => {
    const { actions, projectId, version } = this.props;
    actions.closeActionFormModal();
    history.push(`/collections/${version}/v/${projectId}/create`);
  };

  filterOptions = (collectionName) => {
    let options = [];
    let collections = this.props.events.collections;
    const selectedCollection = collections.find(
      (collection) => collection.collectionName === collectionName,
    );
    let finders = selectedCollection ? selectedCollection.finders : [];
    if (finders.length > 0) {
      options = options.concat(
        finders.map((finder) => ({ value: finder.uuid, label: finder.name })),
      );
    }
    return options;
  };

  render() {
    const { eventAction, actionData } = this.props;
    const { name } = eventAction;
    console.log('eventAction', eventAction.name);
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createActionSettingsSchema(actionData, eventAction)}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  {/* <a
                    onClick={this.closeAllOpenPopup}
                    className="direction-custom-link btn btn-outline-info"
                    title="Create Collection"
                  >
                    <i className="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
                  </a> */}
                  <CustomInputWithIconNoFormGroup
                    icon="select"
                    title="Choose Collection"
                    required={true}
                  >
                    <CustomSelect
                      name="collection"
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.collectionOptions()}
                      value={values['collection']}
                      onChangeValue={this.handleChange}
                      placeholder={'Select Collection'}
                    />
                    <ErrorMessage name={'collection'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </CustomInputWithIconNoFormGroup>
                  <small style={{ paddingLeft: '12%' }}>
                    Select a collection in which want data to get saved.
                  </small>
                </div>

                {name !== 'importCollectionItem' && values['collection'] && (
                  <div className="form-group">
                    <CustomInputWithIconNoFormGroup
                      icon="select"
                      title="Choose Filter"
                      required={true}
                    >
                      <CustomSelect
                        name="filterId"
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.filterOptions(values['collection'])}
                        value={values['filterId']}
                        placeholder={'Select Filter (Optional)'}
                      />
                      <ErrorMessage name={'filterId'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </CustomInputWithIconNoFormGroup>
                    <small style={{ paddingLeft: '12%' }}>
                      Select a filter to be used to export filtered data
                    </small>
                  </div>
                )}
                <CustomInputWithIcon icon="text" title="Success Message" required={true}>
                  <Field
                    type="text"
                    name="successMessage"
                    className="form-control form-control-sm"
                    autoComplete="off"
                    placeholder="Success Message"
                  />
                  <ErrorMessage name="successMessage">
                    {(msg) => <p className="texterror">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
                <CustomInputWithIcon icon="text" title="Error Message" required={true}>
                  <Field
                    type="text"
                    name="errorMessage"
                    className="form-control form-control-sm"
                    autoComplete="off"
                    placeholder="Error Message"
                  />
                  <ErrorMessage name="errorMessage">
                    {(msg) => <p className="texterror">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={this.props.hideModal}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button type="submit" className="btn btn-theme-submit btn-sm">
                  <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.events,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportExportItem);
